import { useState } from 'react';

import config from '@/config';
import AuthService from '@/services/auth.service';
import FadeIn from '@/shared-components/animations/components/FadeIn';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import TimeLeft from '@/shared-components/common/components/TimeLeft';
import InputCode from '@/shared-components/inputs/components/InputCode';
import Text from '@/shared-components/text/components/Text';

import './styles/AuthArtistCodeVerification.css';
import './styles/AuthArtistInputCode.css';

function AuthArtistResendCode({ userEmail, oobCode }) {
  const [loading, setLoading] = useState(false);
  const [cooldown, setCooldown] = useState(null);

  async function resendCode() {
    setLoading(true);

    const { response } = await AuthService.resendArtistCode(userEmail, oobCode);

    if(response.ok) {
      setLoading(false);
      setCooldown(Date.now() + config.app.verification_code_resend_in);
    } else {
      alert("This link has already been used or it has expired.");
    }
  }

  if(cooldown > Date.now()) {
    return (
      <TimeLeft endsIn={cooldown} onEnd={()=>setCooldown(null)}>
        {({ timeLeft })=>(
          <Text className="auth-artist-resend-code disabled font-size-small">
                        Resend in {timeLeft.minutes < 10 ? `0${timeLeft.minutes}` : `${timeLeft.minutes}`}:{timeLeft.seconds < 10 ? `0${timeLeft.seconds}` : `${timeLeft.seconds}`}
          </Text>
        )}
      </TimeLeft>
    );
  }

  return (
    <>
      <Text
        className={[
          `auth-artist-resend-code element-non-selectable ${loading ? "loading" : ""}`,
          "font-size-small"
        ].filter(Boolean).join(" ")}
        onClick={resendCode}>
                Resend code
      </Text>
    </>
  );
}

export default function AuthArtistCodeVerification({ oobCode, isArtistVerified, setIsArtistVerified, userEmail }) {
  const [formState, setFormState] = useState(["", "", "", "", "", ""]);

  const [loading, setLoading] = useState(false);

  const elementName = 'artist_code';

  async function verificationCodeSubmit(newCode) {
    if(newCode.length === 6) {
      const code = newCode.join("");
      setLoading(true); 

      const { response } = await AuthService.verifyArtistCode(code, oobCode);
          
      if(response.ok) {
        setLoading(false);
        setIsArtistVerified(true);
      } else if(response.status === 400) {
        setLoading(false);
        alert("Invalid verification code. Please try again.");
      } else if(response.status === 404) {
        setLoading(false);
        alert("This verification code has already been used or it has expired.");
      }
    }
  }

  const isValidFormState = formState.every((character) => !!character);

  return (
    <>
      <FadeIn>
        <div className="auth-artist-code-verification__container">
          <Text className="auth-artist-code-verification__text font-size-small" paragraph>A verification code has been sent to your email. To verify your identity, please enter the code below.</Text>

          <form onSubmit={e=>{e.preventDefault(); verificationCodeSubmit(formState);}} className="auth-artist-code-verification__form">
            <InputCode
              readOnly={loading}
              value={formState}
              codeType="alphanumeric"
              className="claim-artist-account__input-code"
              onChange={value=>setFormState(value)}
              onComplete={verificationCodeSubmit}
              elementName={elementName}
            >
              {!isArtistVerified && <AuthArtistResendCode userEmail={userEmail} oobCode={oobCode} />}
            </InputCode>

            {!isArtistVerified && <ContinueButton loading={loading} type={'submit'} turnOff={loading || !isValidFormState} >Continue</ContinueButton>}
          </form>
        </div>
      </FadeIn>
    </>
  );
}
